import React from 'react';
import { faCircleXmark } from '@fortawesome/pro-regular-svg-icons/faCircleXmark';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function CircleXmarkRegularIcon(
  props: React.PropsWithChildren<React.HTMLAttributes<SVGElement>>
) {
  return <FontAwesomeIcon icon={faCircleXmark} {...props} />;
}
